export default __webpack_public_path__ + "static/media/prompt.2e4bfb69.png";